import React from 'react'
import Link from 'gatsby-link'

const fees = () => (
  <div>
    <h2>Fees</h2>
    <p>
      Fees are due at the time of service and are payable by cash or check.
      First appointment fee reflects extended office visit, while follow-up
      appointments are less.
    </p>
    <p>
      Please contact me at 206-335-8017 or by email at&#160;
      <a href="mailto:sharkeyacupuncture@gmail.com">
        sharkeyacupuncture@gmail.com
      </a>{' '}
      for my current fee schedule.
    </p>
  </div>
)

export default fees


// WEBPACK FOOTER //
// ./src/pages/fees.js